<template>
  <div>
    <base-table :fields="table" :items="userLines" v-if="userLines && userLines.length !== 0">
      <template #headerText>
        Список линий:
      </template>
      <template #cell(PhoneNumberFormatted)="{item}">
        {{ editNumberLook(item.PhoneNumberFormatted) }}
      </template>
      <template #cell(Lines)="{item}">
        <span>{{ item.Lines.join(', ') }}</span>
      </template>
    </base-table>
    <base-table v-else>
      <template #headerText>
        Список линий:
      </template>
      <template #additional>
        <span>Нет подключенных линий</span>
      </template>
    </base-table>
  </div>
</template>

<script>
import BaseTable from '@/components/shared/BaseTable.vue';
import { employMaskPhone } from '@/additional_helpers/helpers';

export default {
  props: {
    userLines: {
      type: Array,
      require: true
    }
  },

  data() {
    return {
      table: [
        { key: 'PhoneNumberFormatted', label: 'Номер телефона' },
        { key: 'ExternalLinesCount', label: 'Внешние линии' },
        { key: 'InternalLinesCount', label: 'Количество внутренних линий' },
        { key: 'Lines', label: 'Внутренние линии' }
      ]
    };
  },

  components: {
    BaseTable
  },

  methods: {
    editNumberLook(number) {
      return employMaskPhone(number);
    }
  }
};
</script>

<style></style>
